import React, { useEffect, useState } from "react";
import CommonSideNavbar from "../common/CommonSideNavbar";
import {
  agencyDashboard,
  agencyProfile,
  activeLinkDashboard,
} from "../common/allLinks";
import ClientPreviewRequirementCard from "../client-platform-dashboard/ClientPreviewRequirementCard";
import ButtonCommonComponent from "../common/ButtonCommonComponent";
import AgencyDashboardContactDetailsOneModal from "./AgencyDashboardContactDetailsOneModal";
import BreadcrumbMenu from "../common/BreadcrumbMenu";

export default function AgencyDashboardClientProfile() {
  const [isBookMarked, setIsBookMarked] = useState(false);
  const onClickBookmark = () => {
    setIsBookMarked(!isBookMarked);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mt-dashboard-agency-bg">
      <CommonSideNavbar
        dashboardLink={agencyDashboard}
        profileLink={agencyProfile}
        activeLink={activeLinkDashboard}
      />
      <div className="sidenavbar-active-menu-page">
        <div className="mt-title-block custom-d-flex align-items-center justify-content-between">
          <div>
            <BreadcrumbMenu
              menuObj={[
                {
                  title: "Dashboard",
                  type: "goBackButton",
                },
                {
                  title: "Requirement Name",
                },
              ]}
            />
            <h1 className="mt-dashboard-title">3 MERN Stack Developers</h1>
          </div>
          <div className="flex-shrink-0 mt-agency-req-details-buttons-block">
            {!isBookMarked ? (
              <ButtonCommonComponent
                extraClassName="login-btn--modal-btn-border login-btn--px-45 mr-30"
                text="Bookmark"
                onClick={onClickBookmark}
              />
            ) : (
              <ButtonCommonComponent
                extraClassName="login-btn--px-45 mr-30"
                text="Bookmarked"
                onClick={onClickBookmark}
              />
            )}

            <AgencyDashboardContactDetailsOneModal />
          </div>
        </div>
        <ClientPreviewRequirementCard isDisplayAboutCompanyButton={true} />
      </div>
    </div>
  );
}
